import React from 'react'
import Comment from './comment'
import styles from './index.module.less'

export const EmitterEvent = {
  COMMON_TOTAL: 'COMMON_TOTAL'
}

export default ({
  blogId = null,
  collectId = null,
  loginUserInfo = null,
  createUserId = null,
  type = 0,
  sampleId = null,
  total = 0,
  onInitCommentTotal,
}) => {
  return <div className={styles.commentInfo}>
    <div className={styles.titleLine}>
      <div className={styles.point} />
      <div className={styles.mainTitle}>
        评论 <span style={{
        marginLeft: '8px',
        fontWeight: '600',
        color: 'var(--m-text-3)' }}
        >{total}</span>
      </div>
    </div>
    <Comment
      blogId={blogId}
      loginUserInfo={loginUserInfo}
      collectId={collectId}
      createUserId={createUserId}
      type={type}
      sampleId={sampleId}
      onInitCommentTotal={onInitCommentTotal}
    />
  </div>
}
